import { Component, OnDestroy, Input, OnInit, EventEmitter, TemplateRef, ElementRef, ViewChild, Renderer2, Output } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Swiper, { SwiperOptions } from 'swiper';
import { SwiperConfig } from '../../../config/swiper.config'
import { Subject, takeUntil, catchError, pipe, of, map } from 'rxjs';
import { EventService } from 'src/app/services/event.service';
import { ScriptService } from 'src/app/services/script.service';
import { MyProfileService } from 'src/app/services/my-profile.service';
import { environment } from '../../../../environments/environment';
import { EventModel } from 'src/app/models/event.model';
import { TicketModel } from 'src/app/models/ticket.model';
import { SectorModel } from 'src/app/models/sector.model';
import { TicketHoldersComponent } from '../../dialogs/ticket-holders/ticket-holders.component';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/services/order.service';
import { QtyEventType } from '../../components/qty/qty.component';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FormHelper } from '../../../helpers/form.helper';
import { EventData, JsonLDService } from 'src/app/services/structure-data';
import { MapV2Change } from '../../components/mapv2/models/MapV2Change';
import { MapV2Service } from '../../components/mapv2/mapv2.service';
import { MapView } from '../../components/mapv2/models/Map';
import { Title, Meta } from "@angular/platform-browser";
import { select, Store } from '@ngrx/store';
import { PdvSelectors } from 'src/app/store/pdv/selectors';
import { HelperService } from 'src/app/services/helper.service';
import { BancoDoBrasilService } from 'src/app/services/banco-do-brasil.service';

declare let gapi: any;
declare const $: any;

export enum CustomerDataRequirementTypeEnum {
  Obrigatory = 'Obrigatory',
  Optional = 'Optional',
  NotRequired = 'NotRequired',
}

declare const window: any;

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
})
export class EventComponent implements OnInit, OnDestroy {
  public event?: EventModel;
  public sectors?: SectorModel[];
  public tickets?: TicketModel[];
  public ticketscupom?: TicketModel[] = []
  public paymentMethod: any;
  public canShowMapPlace: boolean = false;
  public selectedSector?: string;
  public indexSector: number = 0; // index of selected sector
  public sectorsSwiperConfig: SwiperOptions = SwiperConfig.sectors;
  public buyInOtherSector: boolean = false;
  public swiper?: Swiper;
  public sectorsSwiper?: Swiper;
  public eventId: string = ""
  public titularModalRef?: BsModalRef;
  public mapModalRef?: BsModalRef;
  public halfEntryModalInformationRef?: BsModalRef;
  public openFormPorscheModalRef?: BsModalRef;
  public openPaymentConfirmationModalRef?: BsModalRef;
  public site: string = "https://ingressosa.com"
  public customerName: string = '';
  public loadingBuyedTickets: boolean = false;
  public customerTicketsBuyed: number = 0
  public ticketCupom: string = ''; // cupom de desconto
  public cupomSent: boolean = false
  public ticketCupomError: string = '';
  private unsubscribe$ = new Subject();
  public hasSeatsChart: boolean = false; // tem ou não seatsio
  public selectedSeats: Array<any> = []; // assentos selecionados caso tenha
  public loadingSeatsIo: boolean = false;
  public totalPriceSeats: number = 0; // preço total dos assentos selecionados
  public comissaryId: null | string = null;
  public loading: boolean = false;
  public showFullTickets: boolean = false;
  public hideFullTicket: boolean = false;
  public isCupom: boolean = false;
  public voucherlink: string = "";
  public comissionerMode: boolean | undefined = false;
  public order?: any;
  public eventName?: any;
  public ticketsWithSeats: any = [];
  public allTickets: any = [];
  public orderId: string = '';
  public selectedTickets: any = [];
  private orderMapReserveCode?: string;
  public paymentCompleted: boolean = false;
  public numberOrder: string = '';
  public ticketOrderSubmit: any = [];
  public eventClosed: boolean = false;
  public selectedPaymentMethodId: string = '';
  public selectedPaymentMethod: string = '';
  public selectedPaymentMethodName: string = ""
  public ownerPorscheTicket: boolean = false;
  public ownerPorscheTicketQuantity: number = 0;
  public seatsIOSectors: String[] = []
  // campos para integração com a Feng
  public siteFeng = document.location.host == 'feng.meubilhete.com';
  public fengIntegration = false;
  public fengPlans: any[] = [];
  public fengDiscountKey = '';
  public fengDiscountValue: number = 0;
  public quantityPctValuePartner: number = 0;
  public quantityPctValueInvited: number = 0;
  public quantityPctValueExtra: number = 0;
  public fengEndedSells: boolean = false;
  public hasAnalitycs: boolean = false
  @Input() showBanner: boolean = true
  @Output() sendBanner = new EventEmitter<string | undefined>();
  public categorySports: boolean = false
  public utm: string = ""
  public eventSlug: string | null = '';
  public showMap: boolean = false
  public isCountDown0 = false;
  public showEventInfo = true;

  public quantityPctValuePartnerFixed: number = 0;
  public quantityPctValueInvitedFixed: number = 0;
  public quantityPctValueExtraFixed: number = 0;
  public formHolder!: FormGroup;
  public selectedSeatSector = ""
  public amountSelectedSeatSector: number = 0
  public customerDataRequirementType: CustomerDataRequirementTypeEnum = CustomerDataRequirementTypeEnum.NotRequired;
  public ticketHoldersSubmitted: boolean = false;
  public allSectorsUseSetsio: boolean = false
  public showCupom: boolean = true;
  public showSales: boolean = false
  public loadingSales: boolean = false;
  public cupomSales: object | null = null

  public bbSegurosControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(11),
    Validators.maxLength(11)
  ]);

  logo$ = this.store.pipe(
    select(PdvSelectors.selectCompany),
    map(function (company) {
      return company?.images?.logosite ?? ''
    })
  );

  // Lista de ingressos únicos por cliente
  public ticketIdForOnlyOneCustomer = [
    '188f2b98-1c05-44be-985d-4694f9d2730e',
    '5e28efdf-cb41-4f58-8ff8-ab67ecfbc158',
    '82c075cc-8fec-47d1-9eb3-4ae0f4747285',
    '8fd5498d-713b-4e44-9cdd-0d3162194d82',
    'c82df187-7620-4a12-a272-80f7fc818ec8',
    'eb9e3da0-4be1-485b-958a-9b1e0640798b',
  ];

  public showPub: boolean = true
  public hideAdvertising: any = ['5cc1ee13-cefb-48df-82da-d1911bf1ec9e',
    '9b7d31fd-bc18-4b79-b982-8671fceee58e',
    '680cbfcd-9730-4699-924b-07de354e002a',
    '144d318c-4651-4cbe-a46c-f8abce994b87',
    '8632884b-10f0-4530-962f-7f4f1210bbab',
    'af52b9f4-d133-4ef5-a620-64d5d568eac8']

  @ViewChild('sellLink') sellLink!: any;
  company$ = this.store.pipe(
    select(PdvSelectors.selectCompany),
    map((company) => company ?? null)
  );
  constructor(
    private modalService: BsModalService,
    private eventService: EventService,
    private orderService: OrderService,
    private alertService: AlertService,
    private scriptService: ScriptService,
    private renderer: Renderer2,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private myProfileService: MyProfileService,
    private formBuilder: FormBuilder,
    private formHelper: FormHelper,
    private JsonLDService: JsonLDService,
    private helperService: HelperService,
    private mapV2Service: MapV2Service,
    private titleService: Title,
    private metaService: Meta,
    private store: Store,
    private bbService: BancoDoBrasilService
  ) { }

  ngOnInit(): void {
    this.checkFeng();
    this.loadEvent();

    this.voucherlink = environment.voucherlink



    if (environment.site != null) {
      this.site = environment.site
    }

    if (
      this.authService.getCustomer() != null &&
      this.authService.getCustomer().modeComissioner != null &&
      this.authService.getCustomer().modeComissioner == true
    ) {
      this.comissionerMode = true;
    }

    this.formHolder = this.formBuilder.group(
      {
        doc: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        phone: [''],
        name: ['', Validators.required],
      },
      {
        validators: [this.formHelper.testCpf, this.formHelper.testFullName],
      }
    );

    // if (environment.newIntegration == true) {
    //     let user  = this.authService.getCustomer() as any
    //     user.newIntegration = true
    //     this.authService.saveCustomer(user);
    // }

    this.showCupom = environment.showCupom !== false;

    this.checkNewIntegration();
  }


  removeAccents(s) {
    let r = s.toLowerCase();
    r = r.replace(new RegExp(/\s/g), "");
    r = r.replace(new RegExp(/[àáâãäå]/g), "a");
    r = r.replace(new RegExp(/æ/g), "ae");
    r = r.replace(new RegExp(/ç/g), "c");
    r = r.replace(new RegExp(/[èéêë]/g), "e");
    r = r.replace(new RegExp(/[ìíîï]/g), "i");
    r = r.replace(new RegExp(/ñ/g), "n");
    r = r.replace(new RegExp(/[òóôõö]/g), "o");
    r = r.replace(new RegExp(/œ/g), "oe");
    r = r.replace(new RegExp(/[ùúûü]/g), "u");
    r = r.replace(new RegExp(/[ýÿ]/g), "y");
    r = r.replace(new RegExp(/\W/g), "");
    return r;
  }


  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
    this.removePub()
    this.scriptService.defineDefaultMeta()
    this.scriptService.removeAnalytics("event")
    this.scriptService.removeTagManager("eventtag")
    this.scriptService.removeTagManageriFrame("eventtagf")
  }

  removePub() {
    for (let i = 0; i < document.getElementsByTagName("script").length; i++) {
      if (document.getElementsByTagName("script")[i].id != null) {
        if (document.getElementsByTagName("script")[i].id == "CleverCoreLoader79488") {
          document.getElementsByTagName("script")[i].src = ""
          document.getElementsByTagName("script")[i].id = ""
        }
      }
    }

    for (let i = 0; i < document.getElementsByTagName("div").length; i++) {
      if (document.getElementsByTagName("div")[i].id != null) {
        if (document.getElementsByTagName("div")[i].id.indexOf("clever-79488-") > -1) {
          document.getElementsByTagName("div")[i].remove()
        }
      }
    }
  }

  getCustomerTickets() {
    this.loadingBuyedTickets = true
    this.eventService.getCustomerBuyedTickets(this!.event!.id).subscribe((re) => {
      this.loadingBuyedTickets = false
      this.customerTicketsBuyed = re.total
    })
  }


  /*
    checa se tem comissário
  */
  checkComissioner() {
    // id se houver comissário
    let rfr = this.activatedRoute.snapshot.queryParams['rfr'];
    let url = this.activatedRoute.snapshot.queryParams['url'];

    if (rfr != null && rfr !== '') {
      // caso haja comissário irá salvar em uma variável que será passada ao método de pagamento
      this.comissaryId = rfr;
      if (!this.authService.isLoggednIn()) {
        this.router.navigateByUrl(
          'auth/login?redirect=checkout&eventId=' +
          this.event?.id +
          '&rfr=' +
          rfr
        );
      } else {
        this.router.navigateByUrl(
          'payment-method/' +
          this.activatedRoute.snapshot.paramMap.get('id') +
          '?rfr=' +
          rfr
        );
      }
    }
  }

  /*
    checa nova integração
  */
  checkNewIntegration() {
    // id se houver comissário
    let rfr = this.activatedRoute.snapshot.queryParams['rfr'];
    let url = this.activatedRoute.snapshot.queryParams['url'];
    if (rfr != null && rfr !== '' && url != null && url !== '') {
      this.eventService.loadEventOrder(rfr).subscribe((re: any) => {
        if (!re || re.length == 0) {
          this.alertService.toast({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível encontrar o seu pedido',
          });
          return
        }

        let user = re[0].customer;
        user.phones = re[0].customer.phones;
        //delete user.phones;
        this.authService.saveCustomer(user);

        this.alertService.toast({
          icon: 'success',
          title: 'Usuário logado',
          text: 'Usuário logado',
        });

        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl(
              'payment-method/' +
              this.activatedRoute.snapshot.paramMap.get('id') +
              '?rfr=' +
              rfr +
              '&url=stisa'
            );
          });
      });
      // caso haja comissário irá salvar em uma variável que será passada ao método de pagamento
      // if (!this.authService.isLoggednIn()) {
      //     this.router.navigateByUrl('auth/login?redirect=checkout&eventId='+this.event?.id+'&rfr='+rfr);
      // } else {
      //   this.router.navigateByUrl('payment-method/'+this.activatedRoute.snapshot.paramMap.get('id')+'?rfr='+rfr);
      // }
    }
  }

  public selectSector(sectorId: string): void {
    this.selectedSector = undefined
    const index = this.sectors?.findIndex((s) => s.id == sectorId);
    if (index != -1) {
      this.selectedSector = sectorId;
      this.indexSector = index as number;
      this.selectedSeats = [];
      this.totalPriceSeats = 0;
    }
  }



  public mapV2Change(event: MapV2Change): void {
    this.selectedSector = event.sectorId;
    this.indexSector = this.sectors!.findIndex((s) => s.id == event.sectorId);
    if (this.indexSector <= -1) {
      this.alertService.toast({ icon: 'error', title: 'Erro', text: 'Ingressos indisponíveis para o setor escolhido' })
      return
    }

    // this.sectorsSwiper?.slideTo(this.indexSector);
    // this.sectorsSwiper?.el.scrollIntoView({ block: 'start', inline: 'end', behavior: 'smooth' });

    // const deslocamento = this.sectorsSwiper!.el.offsetTop + 80;
    // window.scrollTo({ top: deslocamento, behavior: 'smooth' });
    // let sector = document.getElementById("sector"+this.selectedSector);

    // sector!.scrollIntoView({ behavior: "smooth", block: "start" });
    let sector = document.getElementById("sector" + this.selectedSector)

    let y = sector!.getBoundingClientRect().top + window.pageYOffset + (-95);


    window.scroll(0, y);


    if (event.place && event.ticket) {
      // Obter ticket selecionado
      const ticket = this.tickets!.find((t) => t.id == event.ticket!.id);
      if (ticket) {
        // Relaciona o place ao ticket
        ticket.mapv2Id = event.place.mapId;
        ticket.mapv2Row = event.place.row;
        ticket.mapv2Number = event.place.number;

        if (event.place.isReserved) {
          const qtyEventType: QtyEventType = {
            target: ticket,
            qty: 1,
            action: 'add',
          };

          for (let i = 0; i < event.place.quantity; i++) {
            this.qtyChanged(qtyEventType);
            qtyEventType.qty++;
          }
        } else {
          const qtyEventType: QtyEventType = {
            target: ticket,
            qty: event.place.quantity,
            action: 'remove',
          };

          for (let i = 0; i < event.place.quantity; i++) {
            this.qtyChanged(qtyEventType);
            qtyEventType.qty--;
          }
        }
      }
    }
  }

  openPaymentConfirmationModal(paymentConfirmationModal: TemplateRef<any>) {
    this.openPaymentConfirmationModalRef = this.modalService.show(
      paymentConfirmationModal, { backdrop: 'static' }
    );
  }

  getHolder() {
    if (this.formHolder.status == 'INVALID') {
      this.alertService.toast({
        icon: 'error',
        title: 'Erro',
        text: 'Preencha todos os campos antes de continuar',
      });
      return;
    } else {
      this.swiper?.slideNext();
    }
  }

  checkCustomerRegister(eve: any) {
    if (eve.srcElement.value.length == 14) {
      this.myProfileService
        .checkCustomerRegisterWithCpf(eve.srcElement.value)
        .subscribe((res: any) => {
          if (res.length >= 1) {
            this.formHolder!.get('name')!.setValue(res[0].name);
            this.formHolder!.get('email')!.setValue(res[0].email);
            this.formHolder!.get('phone')!.setValue(res[0].phones[0]);
          }
        });
    }
  }

  /*
      checa feng
    */
  checkFeng() {
    //  console.log(this.route);
    let sessionId = this.activatedRoute.snapshot.queryParams['session'];
    if (sessionId != null && sessionId !== '') {
      // checa se tem feng, se tiver loga o usuário
      this.myProfileService
        .checkToken(
          sessionId,
          this.activatedRoute.snapshot.paramMap.get('id') as string
        )
        .pipe(
          catchError((error: any) => {
            this.alertService.toast({
              icon: 'error',
              title: 'Erro',
              text: error.error.error.errors[0].msg,
            });
            return of(error);
          })
        )
        .subscribe((res: any) => {

          let user = res.user;
          user.token = res.token;
          user.phones = res.user.phones;
          this.authService.saveCustomer(user);

          this.alertService.toast({
            icon: 'success',
            title: 'Usuário logado',
            text: 'Bem vindo ' + res?.user?.name || '',
          });

          this.loadEvent();
        });
    }
  }

  public get termsOfUseAccepted() {
    return this.orderService.termsOfUseAccepted();
  }

  public get halfTickets() {
    const tickets = this.tickets?.filter((ticket) => {
      if (ticket.type == 'Half' || ticket.type == "SolidarityTicket") {
        return true;
      }
      return false;
    });

    return tickets ?? [];
  }

  public get fullTickets() {
    const tickets = this.tickets?.filter((ticket) => {
      if (ticket.type == 'Full') {
        return true;
      }
      return false;
    });

    return tickets ?? [];
  }

  /*
    preços dos ingressos que foram adicionados usando o componente de ingressos por quantidade
  */
  public amount(ticket?: any): number {
    let fees = true
    if (this.selectedPaymentMethodName == "Dinheiro") {
      fees = false
    }
    return this.orderService.amount(ticket, fees);
  }

  /*
    conta os tickets que vem do componente de ingressos pro quantidade
  */
  public countTickets(ticketId?: string, placeName?: string): number {
    return this.orderService.countTickets(ticketId, placeName);
  }

  public changeQty(eve: QtyEventType): void {
    if (this.event?.allowMapV2 && this.mapV2Service.hasPlaces(this.selectedSector as string)) {
      this.mapV2Service.setView(MapView.PLACES);
      this.mapV2Service.show();
    } else {
      this.qtyChanged(eve);
    }
  }

  private qtyChanged(eve: QtyEventType): void {
    if (eve.action == 'add') {
      // Verifica se o ticket id pertence a regra de somente um ingresso para um cliente
      if (this.ticketIdForOnlyOneCustomer.includes(eve.target.id)) {
        return;
      }

      // se ingressos estiverem no modo cupom
      if (this.isCupom == true) {
        if (eve.target.ticketTagsQuantity != null && eve.target.ticketTagsQuantity !== 0) {
          // verifica se a quantidade de ingressos escolhidos é mais que a quantidade disponível, se for, exibe um erro
          if (eve.qty > eve.target.ticketTagsQuantity) {
            this.alertService.toast({
              icon: 'error',
              title: 'Erro',
              text: 'A quantidade de ingressos é mais do que a quantidade disponível. Você tem ' + eve.target.ticketTagsQuantity + ' ingresso(s) para o cupom ' + this.ticketCupom
            });
            return;
          }
        }
      }

      if (this.fengIntegration == true) {
        if (eve.target.fengPlansPartner && eve.target.fengPlansPartner.length > 0) {
          if (this.quantityPctValuePartner! == 0) {
            this.alertService.toast({ icon: 'error', title: 'Erro', text: 'Não há mais este desconto disponível' }); this.quantityPctValuePartner = 0;
            return;
          }
        }
        else if (eve.target.fengPlansExtra && eve.target.fengPlansExtra.length > 0) {
          if (this.quantityPctValueExtra! == 0) {
            this.alertService.toast({ icon: 'error', title: 'Erro', text: 'Não há mais este desconto disponível' });
            return;
          }
        }
        else if (eve.target.fengPlansInvited && eve.target.fengPlansInvited.length > 0) {
          if (this.quantityPctValueInvited! == 0) {
            this.alertService.toast({ icon: 'error', title: 'Erro', text: 'Não há mais este desconto disponível' });
            return;
          }
        }

        for (let i = 0; i < this.orderService.getAllTickets().length; i++) {
          if (this.orderService.getAllTickets()[i].sectorId !== eve.target.sectorId) {
            this.alertService.toast({ icon: 'error', title: 'Erro', text: 'Não pode comprar ingressos em setores diferentes.' });
            return;
          }
        }
      }
    }

    let ticket = {
      batch: eve.target.batch,
      description: eve.target.description,
      fee: eve.target.fee,
      fees: eve.target.fees,
      ownerPorscheTicket: eve.target.id == 'f66f2e5c-58a0-4531-b3ef-035e3b5bb7af' ? true : false,
      id: eve.target.id,
      ticketTags: this.ticketCupom,
      ticketDateId: eve.target.ticketDateId,
      name: eve.target.name,
      position: eve.target.position,
      price: eve.target.price,
      fengPlansExtra: eve.target.fengPlansExtra,
      fengPlansInvited: eve.target.fengPlansInvited,
      fengPlansPartner: eve.target.fengPlansPartner,
      qty: eve.qty == 0 ? eve.qty + 1 : eve.qty,
      lotId: eve.target.lotId,
      sectorId: eve.target.sectorId,
      unitPrice: eve.target.priceks,
      blacklist: eve.target.blacklist,
      mapv2Id: eve.target.mapv2Id,
      mapv2Row: eve.target.mapv2Row,
      mapv2Number: eve.target.mapv2Number,
      useFacialRecognition: eve.target.useFacialRecognition,
    };

    if (this.fengIntegration == true) {
      if (eve.action == 'add') {
        //  console.log(this.canNewFengDiscount(eve.target));

        if (this.canNewFengDiscount(eve.target) == true) {
          this.changeCountFengDiscount(eve.target, eve.qty, eve.action);
        }
      }

      if (eve.action == 'remove') {
        //  this.orderService.removeTicket(ticket.id);
        this.changeCountFengDiscount(eve.target, eve.qty, eve.action);
      }
    }

    if (eve.action == 'add') {
      this.orderService.addTicket(ticket);
    } else {
      this.orderService.removeTicket(eve.target.id);
    }
  }

  public showTicketHolders() {
    const modal = this.modalService.show(TicketHoldersComponent, {
      class: 'modal-dialog-centered modal-lg page-mobile',
      initialState: {
        customerDataRequirementType: this.customerDataRequirementType
      },
    });

    modal.content?.onComplete.pipe(takeUntil(this.unsubscribe$))
      .subscribe(isCompleted => {
        if (isCompleted) {
          this.ticketHoldersSubmitted = true;
          this.hideTicketHolders();
          this.buy();
        }
      });
  }

  public hideTicketHolders() {
    this.modalService.hide();
  }

  public termsOfUseChanged(ev: any) {
    this.orderService.setTermsOfUse(ev.target.checked);
  }

  public buy() {
    let numberTickets: any = [];
    this.orderService.getAllTickets().forEach((element) => {
      if (
        element.isMapPlace == null ||
        element.isMapPlace == undefined ||
        element.isMapPlace == false
      ) {
        numberTickets[numberTickets.length] = element;
      }
    });

    if (this.event!.limitByCPF! > 0) {
      const limit = this.event!.limitByCPF! - this.customerTicketsBuyed;
      const qttToBuy = this.orderService.getAllTickets().length
      if (this.authService.getCustomer() != null && this.authService.getCustomer().doc != null) {
        if (limit <= 0) {
          this.alertService.toast({
            icon: 'error',
            title: 'Limite atingido',
            text: 'O CPF ' + this.authService.getCustomer().doc + ' já excedeu o numero de compras para esse evento.',
          });
          return
        } else if (limit - qttToBuy < 0 && this.customerTicketsBuyed == 0) {
          this.alertService.toast({
            icon: 'error',
            title: 'Você escolheu mais ingressos do que o permitido',
            text: 'Limite excedido para o CPF ' + this.authService.getCustomer().doc +
              ' este CPF só pode comprar ' + limit + ' ingresso(s) deste evento, porém tentou comprar ' + qttToBuy,
          });
          return
        } else if (limit - qttToBuy < 0 && this.customerTicketsBuyed != 0) {
          this.alertService.toast({
            icon: 'error',
            title: 'Você escolheu mais ingressos do que o permitido',
            text: 'Limite excedido para o CPF ' + this.authService.getCustomer().doc +
              ' este CPF pode comprar somente mais ' + limit + ' ingresso(s) deste evento',
          });
          return
        }
      }
      // else {
      //   this.alertService.toast({
      //     icon: 'error',
      //     title: 'Login necessário!',
      //     text: 'É preciso estar logado para comprar esses ingressos pois exige verificação de CPF'
      //   });
      //   return
      // }

    } else {
      if (this.event?.limitCPF && numberTickets.length > this.event.limitCPF) {
        this.alertService.toast({
          icon: 'error',
          title: 'Limite de ingressos excedido',
          text: `Só é permitido ${this.event.limitCPF} ingressos por CPF.`,
        });
        return
      }
    }



    if (!this.orderService.termsOfUseAccepted()) {
      this.alertService.toast({
        icon: 'error',
        title: 'Aceite os termos de uso',
        text: 'Você precisa aceitar os termos de uso para prosseguir.',
      });
    } else if (this.orderService.countTickets() == 0) {
      this.alertService.toast({
        icon: 'error',
        title: 'Selecione os ingressos',
        text: 'Selecione no mínimo 1 ingresso para continuar.',
      });
    } else if (this.orderService.existsBlacklist()) {
      this.alertService.toast({
        icon: 'error',
        title: 'Blacklist',
        text: `CPF bloqueado para adquirir o ingresso. ${this.orderService.ticketNameBlacklist()}`,
      });
    } else if (this.customerDataRequirementType != CustomerDataRequirementTypeEnum.NotRequired && !this.ticketHoldersSubmitted) {
      this.showTicketHolders()
    } else if (!this.authService.isLoggednIn()) {
      if (this.utm != "" && this.utm != null) {
        this.router.navigateByUrl('/auth/login?redirect=checkout&org=' + this.router.url + "&" + this.utm);
      } else {
        this.router.navigateByUrl('/auth/login?redirect=checkout&org=' + this.router.url);
      }
    } else {

      if (this.comissaryId !== null) {
        this.router.navigateByUrl('/payment-method?rfr=' + this.comissaryId);
      } else {
        this.orderService.currentOrder
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(order => {
            if (order != null) {
              if (order.event != null) {
                if (order.tickets.length >= 1) {
                  if (this.utm != null && this.utm != "") {
                    this.router.navigateByUrl('/payment-method/?' + this.utm);
                  } else {
                    this.router.navigateByUrl('/payment-method/');
                  }
                } else {
                  this.alertService.toast({
                    icon: 'error',
                    title: 'Escolha um ingresso',
                    text: 'Você precisa escolher um ingresso para continuar',
                  });
                }
              } else {
                window.location.reload()
              }
            } else {
              window.location.reload()
            }
          })
      }
    }
  }

  openHalfEntryModalInformation(halfEntryModalInformation: TemplateRef<any>) {
    this.halfEntryModalInformationRef = this.modalService.show(
      halfEntryModalInformation,
      { class: 'modal-dialog-scrollable modal-lg' }
    );
  }

  openFormPorsche(formPorscheModal: TemplateRef<any>) {
    let owner = this.orderService.getAllTickets().filter((ticket: any) => {
      if (ticket.id == 'f66f2e5c-58a0-4531-b3ef-035e3b5bb7af') {
        return ticket;
      }
    });

    if (owner.length >= 1) {
      this.ownerPorscheTicket = true;
      this.ownerPorscheTicketQuantity = owner.length;
    } else {
      this.ownerPorscheTicket = false;
    }

    if (this.ownerPorscheTicket == true) {
      if (!this.orderService.termsOfUseAccepted()) {
        this.alertService.toast({
          icon: 'error',
          title: 'Aceite os termos de uso',
          text: 'Você precisa aceitar os termos de uso para prosseguir.',
        });
      } else if (this.orderService.countTickets() == 0) {
        this.alertService.toast({
          icon: 'error',
          title: 'Selecione os ingressos',
          text: 'Selecione no mínimo 1 ingresso para continuar.',
        });
      } else if (this.orderService.existsBlacklist()) {
        this.alertService.toast({
          icon: 'error',
          title: 'Blacklist',
          text: `CPF bloqueado para adquirir o ingresso. ${this.orderService.ticketNameBlacklist()}`,
        });
      } else if (
        this.event?.limitCPF &&
        this.orderService.countTickets() > this.event.limitCPF
      ) {
        this.alertService.toast({
          icon: 'error',
          title: 'Limite de ingressos excedido',
          text: 'Só é permitido ' + this.event.limitCPF + ' ingressos por CPF.',
        });
      } else {
        this.openFormPorscheModalRef = this.modalService.show(
          formPorscheModal,
          { class: 'modal-dialog-scrollable' }
        );
      }
    } else {
      this.buy();
    }
  }

  public getPorscheOwner(eve: any) {
    if (eve == true) {
      this.buy();
      this.openFormPorscheModalRef?.hide();
    }
  }

  loadOrder() {
    this.orderService.currentOrder
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((order) => {
        this.order = order;
        this.eventName = order!.event!.name;

        this.selectedTickets = this.order.tickets.filter(
          (ticket, index, self) => {
            return (
              index === self.findIndex((ticket2) => ticket2.id === ticket.id) &&
              ticket.placeName == undefined
            );
          }
        );

        this.ticketsWithSeats = this.order.tickets.filter(
          (ticket, index, self) => {
            return (
              index ===
              self.findIndex(
                (ticket2) => ticket2.placeName === ticket.placeName
              ) && ticket.placeName !== undefined
            );
          }
        );

        this.order.tickets.forEach((ticket, index) => {
          if (ticket.orderMapReserveCode != null) {
            this.orderMapReserveCode = ticket.orderMapReserveCode;
          }
        });

        this.allTickets.length = 0;
        this.allTickets = this.allTickets
          .concat(this.selectedTickets, this.ticketsWithSeats)
          .filter((ticket: any) => {
            return ticket !== undefined;
          });
      });
  }

  public sell(titularModal: TemplateRef<any>) {
    if (this.orderService.countTickets() == 0) {
      this.alertService.toast({
        icon: 'error',
        title: 'Selecione os ingressos',
        text: 'Selecione no mínimo 1 ingresso para continuar.',
      });
    } else {
      this.loadOrder();
      this.titularModalRef = this.modalService.show(titularModal, { backdrop: 'static' });
    }
  }

  createSellOrder() {
    // faz loop em todos o tickets
    this.allTickets.forEach((ticket) => {


      // faz loop nos tickets baseado na quantidade de ingressos selecionados de certo ticket
      for (
        let index = 0;
        index < this.countTickets(ticket.id, ticket.placeName);
        index++
      ) {
        // adiciona cada ticket a um array de tickets que será adicionado na flag tickets na variável params
        this.ticketOrderSubmit[this.ticketOrderSubmit.length] = {
          ticketName: ticket.name,
          lotName: ticket.batch,
          ticketDateId: ticket.ticketDateId,
          lotId: ticket.lotId,
          quantity: ticket.qty,
          placeName: ticket.placeName,
          placeId: ticket.placeId,
          placeHoldToken: ticket.placeHoldToken,
          unitPrice: this.selectedPaymentMethodName == "Dinheiro" ? parseFloat(ticket.price).toFixed(2) : parseFloat((ticket.price + ticket.fee).toFixed(2)),
          unitPriceWithoutFee: ticket.price,
          customer: {
            name: this.formHolder!.get('name')!.value,
            doc: this.formHolder!.get('doc')!.value,
            email: this.formHolder!.get('email')!.value,
            phones: [this.formHolder!.get('phone')!.value.trim()],
            loading: false,
          },
          customerRequired: null,
          comissionerId: this.authService.getCustomer().comissionerId,
        };
      }
    });

    // parametros que serão enviados no checkout
    let params = {
      order: {
        amount: parseFloat(this.amount().toFixed(2)),
        ticketTags: this.orderService.getOrderEvent().ticketTags,
        orderMapReserveCode: this.orderMapReserveCode,
        paymentInChange: false,
      },
      tickets: this.ticketOrderSubmit, // array de tickets selecionados
      paymentMethods:
        this.selectedPaymentMethod == ''
          ? []
          : [
            {
              amount: parseFloat(this.amount().toFixed(2)),
              installments: 1,
              paymentMethodId: this.selectedPaymentMethod,
            },
          ],
      customer: {
        id: this.authService.getCustomer().id,
        name: this.authService.getCustomer().name,
        doc: this.authService.getCustomer().doc,
        email: this.authService.getCustomer().email,
        phones: [this.authService.getCustomer().phone[0]],
      },
    };

    this.loading = true;

    // envia compra a API
    this.orderService
      .sendPayment(params)
      .pipe(
        catchError((error: any) => {
          this.loading = false;
          this.orderService.removeAllTickets();
          this.allTickets.length = 0;
          this.alertService.toast({
            icon: 'error',
            title: 'Erro',
            text: error.error.errors[0].msg,
          });
          this.ticketOrderSubmit.length = 0; // em caso de erro, esvazia o arrays de tickets
          if (this.openPaymentConfirmationModalRef) {
            this.openPaymentConfirmationModalRef.hide();
            this.selectedPaymentMethodName = ""
          }
          return of(error);
        })
      )
      .subscribe((res: any) => {
        // se tudo estiver ok, gera a pre order

        if (res.payments.length == 0) {
          this.ticketOrderSubmit.length = 0; // em caso de erro, esvazia o arrays de ticket
          this.paymentCompleted = false;
          this.swiper?.slideNext();
          this.orderId = res.order.id;
          this.numberOrder = res.order.autoincrement;
          this.loading = false;
        }


        if (res.payments.length !== 0 && res.payments[0].success == true) {
          this.swiper?.slideNext();
          this.orderId = res.order.id;
          this.numberOrder = res.order.autoincrement;
          this.paymentCompleted = true;
          this.ticketOrderSubmit.length = 0; // em caso de erro, esvazia o arrays de ticket
          this.loading = false;
        }

        this.loading = false;

        if (this.openPaymentConfirmationModalRef) {
          this.openPaymentConfirmationModalRef.hide();
          this.selectedPaymentMethodName = '';
        }

      });
  }

  openCloseMap(sectorId: string, mapModal: TemplateRef<any>) {
    if (this.showMap == true && this.selectedSector == sectorId) {
      this.showMap = false;
      this.selectedSeatSector = ""
    } else if (this.showMap == false) {
      this.showMap = true;
      this.mapModalRef = this.modalService.show(
        mapModal,
        { class: 'modal-dialog-scrollable modal-lg' }
      );
    } else if (this.showMap == true && this.selectedSector != sectorId) {
      this.modalService.hide()
      this.showMap = true;
    }
    this.selectedSector = sectorId
  }

  copySellLink() {
    (document!.getElementById('selllink') as any)!.select();
    document.execCommand('copy');
  }

  public onSwiper(swiper: any) {
    this.swiper = swiper;
  }

  public holdersSubmitted(e: any) {
    e.preventDefault();
    this.swiper?.slideNext();
  }

  public cardSubmitted(e: any) {
    e.preventDefault();
    this.swiper?.slideTo(0);
  }

  /*
    pega os assentos selecionados no componente seatsio caso tenha de acordo com o tipo do assento (seats ou generalAdmissionArea)
  */
  public getSelectedSeats(eve: any): void {
    if (this.selectedSeats!.length < this.event!.limitCPF!) {
      // ingresso com assento
      eve.ticket = {
        description: null,
        fee: eve.ticket.fee,
        pdvs: eve.ticket.pdvs,
        fees: eve.ticket.fees,
        id: eve.ticket.id,
        ticketDateId: eve.ticket.ticketDateId,
        lotId: eve.ticket.lotId,
        name: eve.ticket.name,
        position: 1,
        price: eve.ticket.price,
        qty: 1,
        isSeatsIo: true,
        objectType: eve.selectedSeat.objectType,
        placeHoldToken: eve.selectedSeat.chart.holdToken,
        sectorId: eve.ticket.sectorId,
        placeName: eve.selectedSeat.id, // nome/id do assento escolhido
      };

      // salva os assentos selecionados bem como o preço e o tipo do ingresso em uma variável
      this.selectedSeats[this.selectedSeats.length] = {
        ticketId: eve.ticket.id,
        ticketDateId: eve.ticket.ticketDateId,
        lotId: eve.ticket.lotId,
        pdvs: eve.ticket.pdvs,
        batchName: eve.ticket.batch,
        ticketName: eve.ticket.name,
        quantity: 1,
        ticketTags: this.ticketCupom,
        price: eve.ticket.price,
        fees: eve.ticket.fees,
        customer: null,
        placeId: null,
        isSeatsIo: true,
        objectType: eve.selectedSeat.objectType,
        placeName: eve.selectedSeat.id,
        placeHoldToken: eve.selectedSeat.chart.holdToken,
        fee: eve.ticket.fee,
      };

      this.calculateTotalPricesSeats('+' + (eve.ticket.price + eve.ticket.fee));

      // passa o ingresso com assento para a função addTickets para poderemos identificar quando o ingresso está ou não salvo e
      // define true para sabermos que o ingresso vem do seatsio pois o seatsio soma valores toda vez que é iniciado (ao trocar de aba e retornar)
      this.orderService.addTicket(eve.ticket, true);
    }
  }

  /*
    remove tickets selecionados no seatsio no order service toda vez que aba mudar, pois os ingressos são carregados
    automaticamente pelo seatsio quando o chart é renderizado, do contrário irá somar novamente com os valores existentes
  */
  public removeTicketsFromOrderService() {
    this.selectedSeats.forEach((seats: any) => {
      this.orderService.removeTicket(seats.ticketId);
    });
  }

  closeMapModal() {
    this.mapModalRef?.hide();
    this.showMap = false;
    document?.getElementById("next")?.scrollIntoView({ behavior: "smooth" })
  }

  /*
    remove os assentos selecionados da variável selectedSeats pelo id do assento
  */
  public removeSelectedSeats(eve: any): void {
    this.selectedSeats.forEach((seat: any, id: number) => {
      if (seat.placeName == eve.id) {
        this.selectedSeats.splice(id, 1);
        this.orderService.removeTicketByPlaceName(eve.id);
        this.calculateTotalPricesSeats('-' + (seat.price + seat.fee));
      }
    });
  }

  getLoadingSeatsIo(eve: any) {
    this.loadingSeatsIo = eve;
  }

  getOpenEvent(eve: any) {
    if (eve == "open") {
      this.showEventInfo = true
      this.isCountDown0 = true
    }

  }

  /*
    calcula o preço dos assentos selecionados
  */
  private calculateTotalPricesSeats(price: string): void {
    this.totalPriceSeats = this.totalPriceSeats + parseInt(price);
  }

  /*
    busca o evento no serviço
  */
  private loadEvent(params: any = {}) {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    const slug = this.activatedRoute.snapshot.paramMap.get('slug');
    this.eventSlug = slug
    this.eventId = id as any

    if (slug) {
      params.slug = slug;
    } else {
      params.eventId = id;
    }

    this.activatedRoute.queryParams.subscribe((res) => {
      this.utm = this.helperService.getUtm(res)
    })

    if (
      this.authService.getCustomer() != null &&
      this.authService.getCustomer().modeComissioner != null &&
      this.authService.getCustomer().modeComissioner == true
    ) {
      params.comissionerId = this.authService.getCustomer().comissionerId;
    }


    this.eventService
      .find(params)
      .pipe(
        takeUntil(this.unsubscribe$),
        catchError((error: any) => {
          console.log(error);
          this.loading = false;
          //this.alertService.toast({  icon: 'error', title: 'Erro',text: error.error.errors[0].msg});
          if (error.error.errors[0].msg == 'Vendas encerradas.') {
            this.fengEndedSells = true;
          } else {
            this.activatedRoute.queryParams.subscribe((res) => {
              let items = this.helperService.getUtm(res)
              if (items != null && items != "") {
                this.router.navigateByUrl('/?tag=' + params.slug + "&" + items);
              } else {
                this.router.navigateByUrl('/?tag=' + params.slug)
              }
            })

          }
          return of(error);
        })
      )
      .subscribe((event) => {
        if (event.error == undefined) {
          this.event = event;

          
          if (this.event?.redirectToExternalLink) {
            window.location.href = this.event.redirectToExternalLink;
          }

          if (this.event?.id == "ec026c2c-4ddb-4549-8ac3-547cb544ff4e") {
            this.router.navigateByUrl('/')
          }

          if (this.event?.categories != null && this.event?.categories.length != null && this.event.categories.length >= 1 && this.event.categories[0].name != null && this.event.categories[0].name.toLowerCase() == "esportes") {
            this.categorySports = true
          }

          if (this?.event?.id == "53ef9bc2-02a6-4f8b-a9ca-bb452fbe98db") {
            this.showEventInfo = false
          }

          this.sendBanner.emit(this.event?.banner)
          this.loadScript()
          this.titleService.setTitle(this!.event!.name);
          this.metaService.updateTag({ property: 'description', content: this!.event!.description as string });
          this.metaService.updateTag({ property: 'og:title', content: this!.event!.name });
          this.metaService.updateTag({ property: 'og:image', content: this!.event!.banner as string });
          if (this.authService.getProducer() != null && this.authService.getProducer().user != null && this.authService.getProducer().user.producerOwnerId != null && this.authService.getProducer().user.producerOwnerId == "28164152-03a1-4bce-b96f-9fe223d32d98" && this.hideAdvertising.indexOf(this.event?.id) > -1) {
            this.showPub = false
            this.removePub()
          }

          this.scriptService.loadAnalytics(this.event?.googleAnalyticsKey as string, "event")

          if (this?.event?.googleTagManagerKey != null) {
            this.scriptService.loadTagManager(this.event?.googleTagManagerKey as string, "eventtag")
          }

          if (this.showPub == true && this.hideAdvertising.indexOf(this.event?.id) <= -1) {
            this.loadScript2();
          }

          this.checkComissioner();

          // se a opção de esconder inteiras estiver marcada, vai exibir botões para exibir e ocultar inteiras
          if (this.event?.hideFullTickets == true) {
            this.hideFullTicket = true;
          }

          if (this.event?.seatsioEventKey != null) {
            this.hasSeatsChart = true;
          }

          if (this.event?.fbPixel != null && this.event?.fbPixel !== "") {
            this.loadScript3(this.event?.fbPixel)
          }

          if (this.authService.isLoggednIn()) {
            this.getCustomerTickets()
          }
          //  console.log(this.event?.integrations);

          if (
            this.event?.integrations &&
            this.event?.integrations.indexOf('Feng') != -1 &&
            this.authService.isLoggednIn() &&
            this.authService.getCustomer().fengPlanId
          ) {
            this.fengIntegration = true;

            if (this.event!.tickets!.length < 1) {
              this.eventClosed = true;
              this.customerName = this.authService.getCustomer().name;
            }


            if (this.authService.isLoggednIn()) {
              this.quantityPctValuePartner = this.authService.getCustomer()
                .quantityPctValuePartner as number;
              this.quantityPctValueInvited = this.authService.getCustomer()
                .quantityPctValueInvited as number;
              this.quantityPctValueExtra = this.authService.getCustomer()
                .quantityPctValueExtra as number;

              this.quantityPctValuePartnerFixed = this.quantityPctValuePartner;
              this.quantityPctValueInvitedFixed = this.quantityPctValueInvited;
              this.quantityPctValueExtraFixed = this.quantityPctValueExtra;
            }
          } else {
            this.fengIntegration = false;
          }

          //  console.log(this.fengIntegration)


          this.sectors = event.sectors;
          this.tickets = event.tickets;
          this.event!.fengIntegration = this.fengIntegration;


          let sectorsWithSeats = 0
          this.sectors?.forEach((sector) => {
            if (sector.useSeats != null && sector.useSeats == true) {
              this.seatsIOSectors[this.seatsIOSectors.length] = sector.name
            }
          })

          // if(sectorsWithSeats == this.sectors!.length){
          //   this.allSectorsUseSetsio = true
          // }

          this.orderService.setEvent(this.event!);
          if (event.sectors) {
            this.selectedSector = event.sectors[0].id;
          }
          if (this.activatedRoute.snapshot.queryParamMap.get('checkout')) {
            this.buy();
          }

          if (this.event?.useGoogleEvents) {
            this.loadStructureData(event);
          }
        }

        let cupom = this.activatedRoute.snapshot.queryParams['cupom'];
        let showSales = this.activatedRoute.snapshot.queryParams['showSales'];

        if (cupom != null && cupom !== '') {
          this.ticketCupom = this.activatedRoute.snapshot.queryParams['cupom'];
          this.sendCupomTicket();
        }

        if (this.event!.id == "c11cc769-8ef3-4586-8182-188ab29cc677") {
          let link = "https://beta.meubilhete.com.br/reveillon-de-villas"
          if (this.ticketCupom  != null && this.ticketCupom  != "") {
            link = "https://beta.meubilhete.com.br/reveillon-de-villas?cupom="+this.ticketCupom
          }          
         window.location.href = link
        }


        if (showSales != null && showSales == 1) {
          this.showSales = true
          this.getCupomSales();
        }

        this.orderService.getAllTickets().forEach((ticket: any) => {
          this.changeCountFengDiscount(ticket, 1, 'add');
        });

        this.checkCustomerDataRequirementType();
      });
  }

  checkCustomerDataRequirementType() {
    if (!this.event) {
      return
    }
    if (this.event.skipCustomerDataOnPdv == true) {
      this.customerDataRequirementType = CustomerDataRequirementTypeEnum.NotRequired;
    } else if (this.event.requireCustomerDataOnPdv == true) {
      this.customerDataRequirementType = CustomerDataRequirementTypeEnum.Obrigatory;
    } else {
      this.customerDataRequirementType = CustomerDataRequirementTypeEnum.Optional;
    }
  }

  getCupomSales() {
    this.loadingSales = true

    this.eventService.getCupomSales(this!.event!.id, this.ticketCupom).subscribe((res) => {
      this.loadingSales = false
      if (res != null && res.length >= 1) {
        this.cupomSales = res[0]
      }
    })
  }

  /*
    aplica cupom
  */
  sendCupomTicket() {
    if (this.ticketCupom == '') {
      this.ticketCupomError = 'Informe um código';
      return;
    } else {
      this.ticketCupomError = '';
    }

    this.getCupom({
      ticketTags: this.ticketCupom || '',
      eventId: this.event!.id || ''
    });
  }

  getCupom(params: { ticketTags: string, eventId: string }) {
    this.loading = true;
    // busca ingressos no evento que tem o cupom se tiver algum
    this.eventService
      .getCupomTicket(params)
      .pipe(
        takeUntil(this.unsubscribe$),
        catchError((error: any) => {
          this.alertService.toast({
            icon: 'error',
            title: 'Falha ao aplicar cupons',
            text: 'Nenhum ingresso encontrado para o código digitado',
          });
          this.loading = false;
          return of(error);
        })
      )
      .subscribe((res: any) => {
        if (res.id != null) {
          this.orderService.removeAllTickets();
          res.ticketTags = this.ticketCupom;
          this.cupomSent = true
          this.loading = false;
          this.isCupom = true;

          this.event = res;

          if (this.event?.categories != null && this.event?.categories.length != null && this.event.categories.length >= 1 && this.event.categories[0].name != null && this.event.categories[0].name.toLowerCase() == "esportes") {
            this.categorySports = true
          }

          this.sendBanner.emit(this.event?.banner)

          this.orderService.setEvent(res);
          // atribui novos setores e ingressos aos setores e ingressos existentes, substituindo-os
          this.sectors = res.sectors;
          this.tickets = res.tickets;


          // define o sector selecionado como o primeiro
          this.selectedSector = res.sectors[0].id;

          let ticketQuantity = 0

          res.tickets.forEach((ticket) => {
            if (ticket.ticketTagsQuantity != null) {
              ticketQuantity = ticketQuantity + ticket.ticketTagsQuantity
            }
          });

          this.alertService.toast({
            icon: 'success',
            title: 'Cupom ativado!',
            text: 'Ingressos do cupom ' + this.ticketCupom + ' carregados.'
            //Quantidade para uso: ' + ticketQuantity,
          });
        } else {
          this.cupomSent = false
        }

      });
  }
  public loadScript() {
    if (window != null) {
      this.hasAnalitycs = true
      this.company$.subscribe((res) => {
        if (res != null && res["googleAnalyticsKey"] != null) {
          this.hasAnalitycs = true
          let script = document.createElement('script');
          script.setAttribute(
            'src',
            'https://www.googletagmanager.com/gtag/js?id=' + res["googleAnalyticsKey"]
          );
          let dataLayer = window.dataLayer || [];
          function gtag(type, content) {
            dataLayer[dataLayer.length] = arguments;
          }
          gtag('js', new Date());

          gtag('config', res["googleAnalyticsKey"]);

          let userData = { user_data: null }
          if (this.authService.isLoggednIn() == true) {
            (userData as any).user_data = {
              email_address: this.authService.getCustomer()["email"],
              phone_number: this.authService.getCustomer()["phone"][0],
              address: {
                first_name: this.authService.getCustomer()["name"].split(" ")[0],
                last_name: this.authService.getCustomer()["name"].split(" ")[1],
                street: this.authService.getCustomer()["addressStreet"] + " " + this.authService.getCustomer()["addressNumber"],
                city: this.authService.getCustomer()["addressDistrict"],
                region: this.authService.getCustomer()["addressState"],
                postal_code: this.authService.getCustomer()["addressPostalCode"],
                country: 'br'
              }
            }
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer[window.dataLayer.length] = {
            event: 'view_item',                                            // nome do evento. Não alterar esse campo.
            page_event: {
              userData,
              page_name: this.event!.name
            }
          }
        }
      })
    }
  }

  loadScript2() {
    if (environment.enableCleverAdvertising) {
      (function (document, window) {
        var a, c = document.createElement("script"), f = window.frameElement;

        c.id = "CleverCoreLoader79488";
        c.src = "https://scripts.cleverwebserver.com/22de7571ff776767c3f3385a9138a14d.js";

        c.async = !0;
        c.type = "text/javascript";
        c.setAttribute("data-target", window.name || (f && f.getAttribute("id")));
        c.setAttribute("data-callback", "put-your-callback-function-here");
        c.setAttribute("data-callback-url-click", "put-your-click-macro-here");
        c.setAttribute("data-callback-url-view", "put-your-view-macro-here");


        try {
          a = parent.document.getElementsByTagName("script")[0] || document.getElementsByTagName("script")[0];
        } catch (e) {
          a = !1;
        }

        a || (a = document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]);
        a.parentNode.insertBefore(c, a);
      })(document, window);
    }
  }

  loadStructureData(event) {
    const eventData: EventData = {
      name: event.name,
      description: event.description,
      startDate: event.dates[0].dateStartEvent,
      //endDate?: string,
      location: {
        name: event.address,
        streetAddress: event.address,
        addressLocality: event.city,
        //postalCode: string,
        addressRegion: event.state,
        addressCountry: 'BR',
      },
      images: [event.imageWeb],
      companyName: environment.name,
      companyUrl: document.location.origin,
      eventUrl: document.location.origin + document.location.pathname,
    };
    this.JsonLDService.insertSchema(this.JsonLDService.eventSchema(eventData));
  }

  // fb pixel
  public loadScript3(fbPixel: any) {

    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ?
          n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }; if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
      t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    (window as any).fbq.disablePushState = true; //not recommended, but can be done
    (window as any).fbq('init', fbPixel);
    (window as any).fbq('track', 'PageView');
    (window as any).fbq('track', 'ViewContent');
    // console.log('Facebook pixel init run!')


    //    if (window != null) {
    // let fbPixelSource = document.createElement('script');
    // fbPixelSource.setAttribute('src','https://connect.facebook.net/en_US/fbevents.js');
    // //document.head.appendChild(fbPixelSrc);
    // let scripts = (document.getElementsByTagName('script') as unknown as Array<any>);
    // document.getElementsByTagName("head")[0].appendChild(fbPixelSource);
    // scripts.forEach((script: any) => {
    //     if (script.src == 'https://connect.facebook.net/en_US/fbevents.js') {
    //       fbq.disablePushState = true;
    //       fbq('init', fbPixel);
    //       fbq('track', 'ViewContent');
    //     }
    // });

  }

  getSelectedMapPlace(eve: any) {
    console.log(eve);
    this.amountSelectedSeatSector = eve[0]
    this.selectedSeatSector = eve[1]
  }

  mapTicketDescription(sectorId: string) {
    let tickets = this.tickets?.filter((ticket) => {
      if (ticket.sectorId == sectorId) {
        return ticket
      }
      return
    })

    return tickets![0]!.description
  }

  canNewFengDiscount(ticket: any) {
    if (
      !(
        (ticket.fengPlansExtra && ticket.fengPlansExtra.length > 0) ||
        (ticket.fengPlansInvited && ticket.fengPlansInvited.length > 0) ||
        (ticket.fengPlansPartner && ticket.fengPlansPartner.length > 0)
      )
    ) {
      return true;
    }

    this.orderService.getAllTickets().forEach((savedTicket: any) => {
      if (savedTicket.sectorId !== this.selectedSector) {
        this.buyInOtherSector = true;
      } else {
        this.buyInOtherSector = false;
      }
    });

    // if (ticket.sectorId !== this.selectedSector) {
    //     buyInOtherSector = true;
    // }

    // this.tickets?.forEach((ticketSelected: any) => {
    //   if (ticketSelected.sectorId !== ticket.sectorId) {
    //     buyInOtherSector = true;
    //   }
    // });

    if (this.buyInOtherSector == true) {
      this.alertService.toast({
        icon: 'error',
        title: 'Erro',
        text: 'Não pode comprar ingressos em setores diferentes.',
      });
    }

    if (ticket.fengPlansPartner && ticket.fengPlansPartner.length > 0) {
      if (this.quantityPctValuePartner <= 0) return false;
    } else if (ticket.fengPlansExtra && ticket.fengPlansExtra.length > 0) {
      if (this.quantityPctValueExtra <= 0) return false;
    } else if (ticket.fengPlansInvited && ticket.fengPlansInvited.length > 0) {
      //console.log(this.quantityPctValueInvited);

      if (this.quantityPctValueInvited <= 0) return false;
    }
    return true;
  }

  changeCountFengDiscount(ticket: any, count: number, action: string) {
    let countInvited = 0;

    if (ticket.fengPlansExtra && ticket.fengPlansExtra.length) {
      if (action == 'remove') {
        this.quantityPctValueExtra += 1;
      } else {
        this.quantityPctValueExtra -= 1;
      }
    }
    if (ticket.fengPlansInvited && ticket.fengPlansInvited.length > 0) {
      if (action == 'remove') {
        this.quantityPctValueInvited += 1;
      } else {
        this.quantityPctValueInvited -= 1;
      }
    }
    if (ticket.fengPlansPartner && ticket.fengPlansPartner.length > 0) {
      if (action == 'remove') {
        this.quantityPctValuePartner += 1;
      } else {
        this.quantityPctValuePartner -= 1;
      }
    }
  }

  getTypeBadge(ticket: any): string {
    const dictionary = {
      'Full': 'Inteira',
      'Half': 'Meia',
      'SolidarityTicket': 'Meia Solidária',
      'Courtesy': 'Cortesia',
      'Undefined': 'Unissex',
      'Male': 'Masculino',
      'Female': 'Feminino'
    }

    if (ticket.shouldHideTypeOnFrontend) {
      return '';
    }

    if (!ticket.type) {
      return 'Unissex - ';
    }

    let translation =
      dictionary[ticket.type] || ticket.type;

    if (ticket.type == 'Half') {
      const ticketNameWithoutAccents = this.removeAccents(ticket.name.toLowerCase());
      if (ticketNameWithoutAccents.indexOf('solidario') > -1 || ticketNameWithoutAccents.indexOf('solidaria') > -1) {
        translation = dictionary['SolidarityTicket']
      } else {
        translation = dictionary['Half']
      }
    }

    return translation + ' - ';
  }

  getTicketGenderBagde(ticketGender: string): string {
    const dictionary = {
      'Male': 'Masculino',
      'Female': 'Feminino',
      'Undefined': 'Unissex',
      'Courtesy': 'Cortesia'
    }

    return dictionary[ticketGender] || ticketGender;
  }

  public aplicarDescontoBBSeguros(): void {
    if (this.bbSegurosControl.invalid) {
      this.alertService.toast({
        icon: 'error',
        title: 'CPF inválido',
        text: 'Por favor, insira um CPF válido.'
      });
      return;
    }

    const cpf = this.bbSegurosControl.value.replace(/[^\d]/g, '');

    this.bbService.getDiscount({ eventId: this.event!.id, cpf }).subscribe((res) => {
      if (res.hasDiscount) {
        this.getCupom({ ticketTags: 'clientebbsegurosporaodorock', eventId: this.event!.id });
        this.alertService.toast({
          icon: 'success',
          title: 'Desconto BB Seguros',
          text: 'Desconto aplicado com sucesso!'
        });
      } else {
        this.alertService.toast({
          icon: 'error',
          title: 'Desconto BB Seguros',
          text: 'Não foi encontrado desconto para o CPF informado.'
        });
      }
    }, (error) => {
      this.alertService.toast({
        icon: 'error',
        title: 'Desconto BB Seguros',
        text: 'Não foi possível aplicar o desconto. Por favor, tente novamente.'
      });
    });

  }
}
